/** Shown when the incoming hostname is not mapped to any merchant — never falls back to another tenant. */
export default function DomainNotConfigured({ domain }) {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6"
      data-testid="domain-not-configured">
      <div className="max-w-lg space-y-5 border border-border bg-card p-8">
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
          404 · domain not configured
        </div>
        <h1 className="text-3xl font-semibold tracking-tight">Domain Not Configured</h1>
        <p className="text-sm text-muted-foreground">
          {domain ? <span className="font-mono text-foreground">{domain}</span> : "This domain"} is not
          connected to any account on this platform, so we cannot load a workspace for it.
        </p>
        <p className="text-xs text-muted-foreground">
          If you are the owner: add this exact domain to your merchant in the platform console, link it to
          the production deployment and configure the required DNS records with your DNS provider. DNS
          configuration and SSL activation are completed through the deployment/domain provider.
        </p>
      </div>
    </div>
  );
}
